module.exports = __webpack_public_path__ + "static/media/8@960w.cea43b6c.jpg";